import DataTable from "react-data-table-component";

const customStyles = {
  table: {
    style: {
      backgroundColor: "#111827",
      color: "#fff",
      borderRadius: "20px",
    },
  },

  headRow: {
    style: {
      backgroundColor: "#111827",
      borderBottom: "1px solid rgba(255,255,255,.08)",
      minHeight: "60px",
    },
  },

  headCells: {
    style: {
      color: "#94a3b8",
      fontSize: "14px",
      fontWeight: 600,
    },
  },

  rows: {
    style: {
      backgroundColor: "#111827",
      color: "#fff",
      minHeight: "60px",

      "&:hover": {
        backgroundColor: "#1f2937",
      },
    },
  },

  pagination: {
    style: {
      backgroundColor: "#111827",
      color: "#fff",
      borderTop: "1px solid rgba(255,255,255,.08)",
    },
  },
};

export default function CustomDataTable({
  columns,
  data,
}) {
  return (
    <DataTable
      columns={columns}
      data={data}
      pagination
      highlightOnHover
      pointerOnHover
      responsive
      customStyles={customStyles}
    />
  );
}